import { render } from "./CustomRestaurantReceipt.vue?vue&type=template&id=c762151e&scoped=true"
import script from "./CustomRestaurantReceipt.vue?vue&type=script&lang=js"
export * from "./CustomRestaurantReceipt.vue?vue&type=script&lang=js"

import "./CustomRestaurantReceipt.vue?vue&type=style&index=0&id=c762151e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c762151e"]])

export default __exports__